// import React, { useEffect, useState } from "react";

// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import ListItemText from "@mui/material/ListItemText";
// import Select from "@mui/material/Select";
// import Checkbox from "@mui/material/Checkbox";
// import AxiosLoading from "../axios/AxiosLoading";
// import { useSelector } from "react-redux";
// import { FormHelperText, Typography } from "@mui/material";
// import { red } from "@mui/material/colors";

// /* const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8; */
// const MenuProps = {
//   PaperProps: {
//     style: {
//       //maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       //width: 250,
//     },
//   },
// };

// const MultiCombo = ({  required= false,
//   // width: 222.67,
//   width= 160,
//   disabled= false,
//   ...props
// }) => {
//   const [codeinfo, setCodeinfo] = useState(props.multiple ? [] : "");
//   const [loading, setLoading] = useState(false);
//   const [multicomboinfo, setMulticomboinfo] = useState([]);
//   const reduxCodeInfo = useSelector((state) => state.CodeInfo?.data);
//   let codeNm
//   const doRetrieve = async () => {
//     try {
//       setLoading(true);
//       if (props.multiple === false) {  
//         if (props.comboText==='담당사원'){
//           codeNm="미지정";
//         }else{
//           // codeNm="전체";
//           codeNm=props.codeName?props.codeName:"전체";
//         };

//         const comboOption = [
//           {
//             code_cd: "",
//             code_nm: codeNm
//           },
//         ];
//         setMulticomboinfo(comboOption.concat(reduxCodeInfo.filter(params => params.codetype_cd === props.codetype)));        
//         setCodeinfo([""]);
//       } else {
//         setMulticomboinfo(reduxCodeInfo.filter(params => params.codetype_cd === props.codetype));
//       }

//     } catch (error) {
//       window.alert(error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   //콤보박스 호출
//   useEffect(() => {
//     doRetrieve();
//     // eslint-disable-next-line
//   }, []);
//   useEffect(() => {
//     if (!props.value) {
//       if (multicomboinfo.length !== 0 && !props.multiple) setCodeinfo([""]);
//       return;
//     }
//     setCodeinfo(
//       // On autofill we get a stringified value.
//       typeof props.value === "string" ? props.value.split(",") : props.value
//     );
//   }, [props.value, multicomboinfo, props.multiple]);

//   //콤보박스 이벤트
//   const handleChange = (e) => {
//     const {
//       target: { value },
//     } = e;
//     setCodeinfo(
//       // On autofill we get a stringified value.
//       typeof value === "string" ? value.split(",") : value
//     );
//     props.onChange(e, codeinfo, ); 
//   };

//   return (
//     <>
//       {loading && <AxiosLoading />}
//       <FormControl
//         sx={
//           props.required && !props.disabled
//             ? {
//                 m: 1,
//                 width: width,
//                 "& .MuiInputLabel-root ": { color: red[600] },
//                 "& .MuiInputLabel-root .Mui-focused": { color: red[600] },
//                 /* "& .MuiOutlinedInput-root ": {
//                 " fieldset": { borderColor: red[600] },
//                 "&.Mui-focused fieldset": { borderColor: red[600] },
//                 "&:hover fieldset": { borderColor: red[100] }, 
//               },*/
//               }
//             : {
//                 m: 1,
//                 width: width,
//               }
//         }
//         size="small"
//         required={props.required}
//         error={!props.validation ? false : true}
//       >
//         <InputLabel //id="demo-multiple-checkbox-label"
//           sx={{
//             fontSize: "12px",
//             color: props.color ? props.color : "#000000",
//           }}
//         >
//           {props.comboText}
//         </InputLabel>
//         <Select
//           labelId="demo-multiple-checkbox-label"
//           id="demo-multiple-checkbox"
//           sx={{
//             width: width ? "222.67" : width,
//           }}
//           multiple={props.multiple}
//           value={codeinfo}
//           name={props.name}
//           readOnly={props.readOnly}
//           disabled={props.disabled}
//           onChange={(e) => handleChange(e)}
//           input={<OutlinedInput label={props.comboText} />}
//           renderValue={(selected) =>
//             selected
//               .map(
//                 (obj) =>
//                   multicomboinfo[
//                     multicomboinfo.findIndex((key) => key["code_cd"] === obj)
//                   ]?.code_nm
//               )
//               .join(", ")
//           }
//           MenuProps={MenuProps}
//         >
//           {multicomboinfo.map((info, index) => (
//             <MenuItem
//               key={index}
//               value={info.code_cd}
//               style={{
//                 paddingTop: "0px",
//                 paddingBottom: "0px",
//                 paddingLeft: "1px",
//                 paddingRight: "1px",
//               }}
//             >
//               {props.multiple ? (
//                 <Checkbox
//                   checked={codeinfo?.indexOf(info.code_cd) > -1}
//                   style={{
//                     padding: "2px",
//                     // paddingLeft:'3px',
//                     // marginTop:'1px',
//                     // marginBottom:'1px'
//                   }}
//                 />
//               ) : null}
//               <ListItemText
//                 primary={
//                   <Typography
//                     style={{
//                       fontSize: "15px",
//                       // color: '#ff6f00'
//                     }}
//                   >
//                     {info.code_nm}
//                   </Typography>
//                 }
//               />
//             </MenuItem>
//           ))}
//         </Select>
//         <FormHelperText>{props.validation}</FormHelperText>
//       </FormControl>
//     </>
//   );
// };

// // //props default value
// // MultiCombo.defaultProps = {
// //   required: false,
// //   // width: 222.67,
// //   width: 160,
// //   disabled: false,
// // };

// export default React.memo(MultiCombo);


import React, { useEffect, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import AxiosLoading from "../axios/AxiosLoading";
import { useSelector } from "react-redux";
import { FormHelperText, Typography } from "@mui/material";
import { red } from "@mui/material/colors";

const MenuProps = {
  PaperProps: {
    style: {
      // maxHeight, width 등 필요한 경우 설정
    },
  },
};

const MultiCombo = ({
  multiple = false,
  required = false,
  width = 160,
  disabled = false,
  comboText = "",
  codeName,
  codetype,
  value,
  onChange,
  name,
  readOnly = false,
  validation,
  color = "#000000",
  ...props
}) => {
  const [codeinfo, setCodeinfo] = useState(multiple ? [] : "");
  const [loading, setLoading] = useState(false);
  const [multicomboinfo, setMulticomboinfo] = useState([]);
  const reduxCodeInfo = useSelector((state) => state.CodeInfo?.data);

  const doRetrieve = async () => {
    try {
      setLoading(true);
      if (!multiple) {
        const defaultLabel =
          comboText === "담당사원"
            ? "미지정"
            : codeName
            ? codeName
            : "전체";
        const comboOption = [{ code_cd: "", code_nm: defaultLabel }];
        const list = reduxCodeInfo.filter(
          (item) => item.codetype_cd === codetype
        );
        setMulticomboinfo([...comboOption, ...list]);
        setCodeinfo("");
      } else {
        setMulticomboinfo(
          reduxCodeInfo.filter((item) => item.codetype_cd === codetype)
        );
      }
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    doRetrieve();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!value) {
      if (multicomboinfo.length && !multiple) {
        setCodeinfo("");
      }
      return;
    }
    setCodeinfo(
      typeof value === "string" ? value.split(",") : value
    );
  }, [value, multicomboinfo, multiple]);

  const handleChange = (e) => {
    const {
      target: { value: selected },
    } = e;
    const newValue = typeof selected === "string" ? selected.split(",") : selected;
    setCodeinfo(newValue);
    onChange(e, newValue);
  };

  return (
    <>
      {loading && <AxiosLoading />}
      <FormControl
        size="small"
        required={required}
        error={!!validation}
        sx={{
          m: 1,
          width,
          ...(required && !disabled && {
            "& .MuiInputLabel-root": { color: red[600] },
            "& .MuiInputLabel-root.Mui-focused": { color: red[600] },
          }),
        }}
      >
        <InputLabel sx={{ fontSize: 12, color }}>{comboText}</InputLabel>
        <Select
          label={comboText}
          multiple={multiple}
          value={codeinfo}
          name={name}
          readOnly={readOnly}
          disabled={disabled}
          onChange={handleChange}
          input={<OutlinedInput label={comboText} />}
          renderValue={(selected) =>
            (selected || [])
              .map(
                (code) =>
                  multicomboinfo.find((item) => item.code_cd === code)
                    ?.code_nm
              )
              .join(", ")
          }
          MenuProps={MenuProps}
          sx={{ width }}
          {...props}
        >
          {multicomboinfo.map((info, idx) => (
            <MenuItem
              key={idx}
              value={info.code_cd}
              sx={{ py: 0, px: 1 }}
            >
              {multiple && (
                <Checkbox
                  checked={codeinfo.indexOf(info.code_cd) > -1}
                  sx={{ p: "2px" }}
                />
              )}
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: 15 }}>
                    {info.code_nm}
                  </Typography>
                }
              />
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{validation}</FormHelperText>
      </FormControl>
    </>
  );
};

export default React.memo(MultiCombo);
